/**
 * Represents a method to the Web Client API. A method has a name, input parameters and an output parameters
 */
export interface WebClientMethod<TIn, TOut> {
  name: string;

  // Needed a reference to TIn and TOut, not sure if this is needed otherwise
  isValidInput(input?: TIn): boolean;
  isValidOutput(output?: TOut): boolean;
}

/**
 * An implementation of a WebClientMethod
 */
export class DefaultWebClientMethod<TParams, TResponse> implements WebClientMethod<TParams, TResponse> {

  public constructor(
    public name: string
  ) { }

  // public method: string;
  public isValidInput(input?: TParams): boolean { return !!input; }
  public isValidOutput(output?: TResponse): boolean { return !!output; }
}

/**
 * An implementation of a WebClientMethod that requires no input
 */
export class NoInputWebClientMethod<TResponse> implements WebClientMethod<void, TResponse> {

  public constructor(
    public name: string
  ) { }

  // public method: string;
  public isValidInput(input?: void): boolean { return !input; }
  public isValidOutput(output?: TResponse): boolean { return !!output; }
}

/**
 * An implementation of a WebClientMethod that requires no output
 */
export class NoOutputWebClientMethod<TParams> implements WebClientMethod<TParams, void> {

  public constructor(
    public name: string
  ) { }

  // public method: string;
  public isValidInput(input?: TParams): boolean { return !!input; }
  public isValidOutput(output?: void): boolean { return !output; }
}
